import { Handle, Position, useNodeConnections, useReactFlow } from '@xyflow/react'
import { useState } from 'react'
import { MenuItems } from '../panel'
import type { FlowNodeTypes } from '../types'

export const ComponentMenu = () => {
  const { getNode } = useReactFlow()
  const [isOpen, setIsOpen] = useState(true)
  const handleConnections = useNodeConnections({
    handleType: 'target',
  })

  // Get source nodes from connections
  const sourceNodes = handleConnections
    .map((connection) => {
      const sourceNode = getNode(connection.source)
      return sourceNode
    })
    .filter(Boolean)

  return (
    <div className="relative nodrag cursor-default bg-background nowheel">
      <Handle
        position={Position.Top}
        type="target"
        className="absolute left-1/2 -top-2 -translate-x-1/2 invisible"
      />
      <MenuItems
        open={isOpen}
        onOpenChange={setIsOpen}
        isDrag
        sourceNodeId={sourceNodes[0]?.id}
        currentNodeType={sourceNodes[0]?.type as FlowNodeTypes}
      />
    </div>
  )
}
